






import { Component, Vue } from 'vue-property-decorator'
import TopBarView from '@/features/navBar/views/TopBar.vue'

@Component({
  components: {
    TopBarView
  }
})
export default class General extends Vue {}
